import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { RouterService } from 'src/app/libs/data-access/services/router/router.service';

@Component({
  selector: 'tic-event-summary-card',
  templateUrl: './event-summary-card.component.html',
  styleUrls: ['./event-summary-card.component.scss']
})
export class EventSummaryCardComponent {
  @Input() eventResult: any;
  @Input() eventCount: any;
  @Output() eventSelection: EventEmitter<any> = new EventEmitter();
  eventPrice: number;
  selectSeatVisible: boolean = false;  
  tooltipText: string = '';
  tooltipStyle: any = {};
  isViewOrder: boolean=false;
  private destroy$ = new Subject<void>();

  constructor(private routerService: RouterService) {
    this.routerService
    .getUrlParams()
    .pipe(takeUntil(this.destroy$))
    .subscribe((res) => {
      //TODO: complete types
      if(res["orderDetail"] && res["viewOrder"]) {
        this.isViewOrder = true;
      }
    });
  }

  convertToDate(dateString: string): Date {
    const [day, month, year] = dateString.split('/').map(Number);
    return new Date(year, month - 1, day); // Month is zero-based
  }

  
  showTooltip(event: MouseEvent, text: string) {
    this.tooltipText = text;
    this.tooltipStyle = {
      display: 'block',
      top: event.clientY + 10 + 'px',
      left: event.clientX + 10 + 'px'
    };
  }

  hideTooltip() {
    this.tooltipStyle = {
      display: 'none'
    };
  }
  
  showDetail(){
    this.selectSeatVisible = true;
  }

  hideDetail(){
    this.selectSeatVisible = false;
  }

  selectedOptions(event: any){
    this.eventResult = event;
    this.eventSelection.emit({ event });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
